import { render, staticRenderFns } from "./chooseClient.vue?vue&type=template&id=372b2028&"
import script from "./chooseClient.vue?vue&type=script&lang=js&"
export * from "./chooseClient.vue?vue&type=script&lang=js&"
import style0 from "./chooseClient.vue?vue&type=style&index=0&id=372b2028&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports